import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { COLORS } from 'apps/web_forms/utils/constants';
import CheckIcon from 'apps/web_forms/assets/check.svg';

const StyledProgressCircle = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .progress-ring {
    z-index: 2; /* TODO: remove? it's causing issues, appearing over dropdowns */
  }

  .progress-ring__circle {
    transition: 0.35s stroke-dashoffset;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
  }

  .progress-ring-placeholder {
    position: absolute;
    top: 0;
    left: 0;
  }

  .check-icon {
    position: absolute;
    width: 16px;
    height: 16px;
    top: calc(50% - 8px);
    left: calc(50% - 8px);
    border-radius: 50%;
    transition: all 200ms;
  }
`;

const ProgressCircle = ({ progress, color }) => {
  const circleRef = useRef(null);
  const [currentProgress, setCurrentProgress] = useState(0);

  useEffect(() => {
    if (progress >= 0 && progress <= 100) {
      setCurrentProgress(progress);
    }
  }, [progress]);

  useEffect(() => {
    if (!circleRef || !circleRef.current) return;

    const circle = circleRef.current;

    const radius = circle.r.baseVal.value;
    const circumference = radius * 2 * Math.PI;

    circle.style.strokeDasharray = `${circumference} ${circumference}`;
    circle.style.strokeDashoffset = `${circumference}`;

    const offset = circumference - (currentProgress / 100) * circumference;
    circle.style.strokeDashoffset = offset;
  }, [circleRef, currentProgress]);

  return (
    <StyledProgressCircle>
      <svg className='progress-ring' width='28' height='28'>
        <circle
          ref={circleRef}
          className='progress-ring__circle'
          stroke={color}
          strokeWidth='3'
          fill='transparent'
          r='12'
          cx='14'
          cy='14'
        />
      </svg>
      <svg className='progress-ring-placeholder' width='28' height='28'>
        <circle
          stroke='#DDD'
          strokeWidth='3'
          fill='transparent'
          r='12'
          cx='14'
          cy='14'
        />
      </svg>
      <CheckIcon
        className='check-icon'
        style={{ opacity: progress === 100 ? 1 : 0 }}
      />
    </StyledProgressCircle>
  );
};

ProgressCircle.propTypes = {
  progress: PropTypes.number,
  color: PropTypes.string,
};

ProgressCircle.defaultProps = {
  progress: 0,
  color: COLORS.lighterPrimary,
};

export default ProgressCircle;
